import React, { MouseEvent } from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { IChat, IChatsRecord } from '../../../../interfaces/chats';
import EventHeader from '../EventHeader/EventHeader';
import ChatItem from '../ChatItem/ChatItem';
import { ChatMenuAnchor } from '../ChatContextMenu/ChatContextMenu';
import { canMarkChatUnread, hasChatMessages, hasUnreadChat } from '../../../../utils/messaging/chatListState';
import './eventAccordion.scss';

interface EventAccordionProps {
  event: IChatsRecord;
  isExpanded: boolean;
  eventIndex: number;
  onToggle: (eventId: string) => void;
  selectedChatId?: string;
  onChatClick: (eventId: string, chatId: string) => void;
  chatIndexOffset: number;
  isLastEvent?: boolean;
  sdk: any;
  openMenuKey?: string | null;
  onEventMenu?: (event: IChatsRecord, anchor: ChatMenuAnchor) => void;
  onChatMenu?: (event: IChatsRecord, chat: IChat, anchor: ChatMenuAnchor) => void;
}

export const eventMenuKey = (eventId: string) => `event:${eventId}`;
export const chatMenuKey = (chatId: string) => `chat:${chatId}`;

const EventAccordion: React.FC<EventAccordionProps> = ({
  event,
  isExpanded,
  eventIndex,
  onToggle,
  selectedChatId,
  onChatClick,
  chatIndexOffset,
  isLastEvent,
  sdk,
  openMenuKey,
  onEventMenu,
  onChatMenu,
}) => {
  const openEventMenu = onEventMenu ? (anchor: ChatMenuAnchor) => onEventMenu(event, anchor) : undefined;

  return (
    <Accordion
      key={event.eventId}
      expanded={isExpanded}
      onChange={() => onToggle(event.eventId)}
      className="eventAccordion"
      disableGutters
    >
      <AccordionSummary
        className={`eventAccordionSummary ${openMenuKey === eventMenuKey(event.eventId) ? 'menuOpen' : ''}`}
        onContextMenu={
          openEventMenu
            ? (contextEvent: MouseEvent) => {
                contextEvent.preventDefault();
                openEventMenu({ x: contextEvent.clientX, y: contextEvent.clientY });
              }
            : undefined
        }
      >
        <EventHeader
          event={event}
          isExpanded={isExpanded}
          isMenuOpen={openMenuKey === eventMenuKey(event.eventId)}
          onMoreClick={
            openEventMenu ? (clickEvent) => openEventMenu({ element: clickEvent.currentTarget }) : undefined
          }
        />
      </AccordionSummary>
      <AccordionDetails className="eventAccordionDetails">
        {/* need event index to get the avatar background color */}
        {event.chats.map((chat, chatIndex) => (
          <ChatItem
            key={chat.id}
            chat={chat}
            event={event}
            isSelected={selectedChatId === chat.id}
            onChatClick={onChatClick}
            index={chatIndexOffset + chatIndex}
            isLastChat={isLastEvent && chatIndex === event.chats.length - 1}
            sdk={sdk}
            chatIndex={eventIndex}
            isMenuOpen={openMenuKey === chatMenuKey(chat.id)}
            onOpenMenu={
              onChatMenu && canMarkChatUnread(chat) && (hasUnreadChat(chat) || hasChatMessages(chat))
                ? (anchor) => onChatMenu(event, chat, anchor)
                : undefined
            }
          />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default EventAccordion;
